import { Injectable } from '@angular/core';
import { ApiService } from './services/api/api.service';

@Injectable({
    providedIn: 'root',
})
export class PdfreportService {
    constructor(private apiService: ApiService) {}

    public getReportPdf(data: PdfReportRequest) {
        const selectedWorkareaIds = Array.isArray(data.workarea_ids)
            ? data.workarea_ids.filter(id => Number.isFinite(id) && id > 0)
            : [];
        return this.apiService.postBlobCall(`pdf/reportpdf`, {
            projectId: data.projectId,
            status: Object.keys(data.status).filter(key => data.status[key]),
            workarea_per_page: data.workarea_per_page,
            include_workarea_table: data.include_workarea_table,
            pdf_style_key: data.pdf_style_key || undefined,
            map_type: data.map_type,
            workarea_ids: selectedWorkareaIds.length ? selectedWorkareaIds.join(',') : '',
            phase_document_reply_ids: data.phase_document_reply_ids?.length
                ? data.phase_document_reply_ids.join(',')
                : undefined,
            report_files: data.report_files?.length ? data.report_files.join(',') : undefined,
        });
    }

    public getWorkareaPdf(workareaId?: number, pdfStyleKey?: string) {
        return this.apiService.getBlobCall(`pdf/workareapdf`, { workareaId, pdf_style_key: pdfStyleKey });
    }
}

export interface PdfReportRequest {
    projectId?: number;
    status: any;
    workarea_per_page: boolean;
    include_workarea_table: boolean;
    pdf_style_key?: string | null;
    pdf_style_name?: string | null;
    map_type?: string;
    workarea_ids?: number[];
    phase_document_reply_ids?: number[];
    report_files?: string[];
}
